const itemKey = (item = {}) => {
  const id = item?.id ?? item?.item_id ?? item?.inventory_item_id;
  if (id !== undefined && id !== null && String(id).trim()) return `id:${String(id)}`;
  return `name:${String(item?.name || item?.item_name || "").trim().toLowerCase()}`;
};

/**
 * Keeps the API's frequently-used order at the front, then appends every
 * remaining active inventory item alphabetically. The full item objects come
 * from allItems so quick-select always has the latest UOM and stock metadata.
 */
export const rankAllInventoryItems = (allItems = [], frequentItems = []) => {
  const frequentRank = new Map();
  (Array.isArray(frequentItems) ? frequentItems : []).forEach((item, index) => {
    const key = itemKey(item);
    if (!frequentRank.has(key)) frequentRank.set(key, index);
  });

  const uniqueItems = new Map();
  (Array.isArray(allItems) ? allItems : []).forEach((item) => {
    const key = itemKey(item);
    if (!uniqueItems.has(key)) uniqueItems.set(key, item);
  });

  return Array.from(uniqueItems.values()).sort((left, right) => {
    const leftRank = frequentRank.get(itemKey(left));
    const rightRank = frequentRank.get(itemKey(right));
    const leftFrequent = leftRank !== undefined;
    const rightFrequent = rightRank !== undefined;

    if (leftFrequent && rightFrequent) return leftRank - rightRank;
    if (leftFrequent) return -1;
    if (rightFrequent) return 1;
    return String(left?.name || left?.item_name || "").localeCompare(
      String(right?.name || right?.item_name || ""),
      undefined,
      { sensitivity: "base" }
    );
  });
};

